/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CategoryRent: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M7.39746 4.20113C7.64787 4.01226 7.97281 3.95201 8.27441 4.03805L22.2744 8.03805C22.7037 8.16071 23 8.55348 23 8.99996V20C23 20.5176 22.6067 20.9437 22.1025 20.9951L22 21H2C1.44772 21 1 20.5522 1 20V14C1 13.7073 1.12817 13.4317 1.34668 13.2431L1.44531 13.1679L7 9.46481V4.99996C7 4.68617 7.14695 4.3901 7.39746 4.20113ZM3 14.5351V19H7V11.8681L3 14.5351ZM9 19H12V15L12.0049 14.8974C12.0562 14.3933 12.4823 14 13 14H17L17.1025 14.0048C17.6067 14.0562 18 14.4823 18 15V19H21V9.75387L9 6.32516V19ZM14 19H16V16H14V19Z'
      fill='currentColor'
    />
  </React.Fragment>
)
